import React from 'react';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import cn from 'classnames';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { useRequestReasonConfig } from '../../../context';
import { ReactComponent as DeleteIcon } from 'assets/img/icons/delete-muted.svg';
import { ReactComponent as DragIcon } from 'assets/img/icons/reorder-dots.svg';

const DragHandle = SortableHandle(({ isDisabled }) => (
  <UiKit.Button
    variant="ghost"
    disabled={isDisabled}
    className={cn({ 'cursor-grab': !isDisabled })}
  >
    <DragIcon />
  </UiKit.Button>
));

const SortableItem = SortableElement(
  ({ value, error, isDisabled, isProcessing, onChange, onDelete }) => {
    return (
      <UiKit.Flex gap={8} className={styles.item}>
        <DragHandle isDisabled={isDisabled || isProcessing} />
        <UiKit.Input
          value={value}
          onChange={onChange}
          placeholder="eg. bigger than expected"
          error={error}
          disabled={isDisabled || isProcessing}
          className="flex-grow-1"
        />
        <UiKit.Button
          variant="ghost"
          onClick={onDelete}
          disabled={isDisabled || isProcessing}
        >
          <DeleteIcon className="delete" />
        </UiKit.Button>
      </UiKit.Flex>
    );
  }
);

export default function Item({ index }) {
  const {
    data,
    errors,
    isDisabled,
    isProcessing,
    onChange
  } = useRequestReasonConfig();

  const subReasonsData = _get(data, 'sub_reasons_data', {});
  const subReasons = _get(subReasonsData, 'sub_reasons', []);
  const allowMultiple = _get(subReasonsData, 'allow_multiple', false);
  const value = _get(subReasonsData, `sub_reasons[${index}]`, '');
  const error = _get(errors, `sub_reasons_data.sub_reasons[${index}]`, '');

  const onSubReasonChange = value => {
    const newSubReasons = [...subReasons];
    newSubReasons[index] = value;
    onChange(
      {
        sub_reasons_data: {
          allow_multiple: allowMultiple,
          sub_reasons: newSubReasons
        }
      },
      { validationPaths: [`sub_reasons_data.sub_reasons.${index}`] }
    );
  };

  const onSubReasonDelete = () => {
    const newSubReasons = subReasons.filter((_, i) => i !== index);
    const hasSubReasons = newSubReasons.length > 0;
    onChange(
      {
        allows_sub_reasons: hasSubReasons,
        sub_reasons_data: !hasSubReasons
          ? null
          : {
              allow_multiple: allowMultiple,
              sub_reasons: newSubReasons
            }
      },
      { validationPaths: [`sub_reasons_data.sub_reasons.${index}`] }
    );
  };

  return (
    <SortableItem
      index={index}
      value={value}
      error={error}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
      onChange={onSubReasonChange}
      onDelete={onSubReasonDelete}
    />
  );
}
